import UserService from '../services/user.service';
import { User, UserGroup, Company } from './models/models';

export default {
  namespaced: true,
  state: {
    userId: null,
    totalUsers: null,
    query: {
      filters: {},
      sort: [],
      page: 1,
      limit: 30,
    },
    isNewUser: null,
    isUserModalOpen: null,
  },
  mutations: {
    isUserModalOpen(state, isUserModalOpen) {
      state.isUserModalOpen = isUserModalOpen;
    },
    userId(state, userId) {
      state.userId = userId;
    },
    totalUsers(state, totalUsers) {
      state.totalUsers = totalUsers;
    },
    isNewUser(state, isNewUser) {
      state.isNewUser = isNewUser;
    },
    queryProps(state, props) {
      state.query = Object.assign({}, state.query, props);
    },
  },
  actions: {
    suggestUsers(state, props) {
      return UserService.suggestUsers(props);
    },
    init({ dispatch }) {
      dispatch('getUsersGroups');
    },
    newUser({ commit }, companyId) {
      User.new()
        .then((user) => {
          if (companyId) {
            user.$update({
              company_id: companyId,
            });
          }
          commit('userId', user.id);
        });
    },
    openUserModal({ commit }, props) {
      commit('isNewUser', props.isNewUser);
      commit('userId', props.id);
      commit('isUserModalOpen', true);
    },
    updateUserProps({ state }, props) {
      if (props.hasOwnProperty('company')) {
        Company.insert({ data: props.company });
      }

      User.update({
        where: state.userId,
        data: props,
        // create: ['companies'], // should work, but isn't :(
      });
    },
    getUsers({ state, commit }, params) {
      const query = JSON.parse(JSON.stringify(state.query));
      if (params.company_id) {
        query.filters.company_id = params.company_id;
      }
      if (params.group_code) {
        query.filters.group_code = params.group_code;
      }
      return UserService.getUsers(query)
        .then((res) => {
          commit('totalUsers', res.total);
          User.create({
            data: res.data,
            insertOrUpdate: ['user_groups', 'companies'],
          });
        });
    },
    getUsersGroups() {
      return UserService.getUsersGroups()
        .then((usersGroups) => UserGroup.create({ data: usersGroups }));
    },
    generateNewPassword({ state }) {
      return UserService.generateUserPassword(state.userId);
    },
    getUser({ commit }, id) {
      return UserService.getUser(id)
        .then((user) => {
          commit('userId', user.id);
          User.insert({ data: [user] });
        });
    },
    async createUser({ commit, getters }, groupCode) {
      const res = await UserService.createUser({
        ...getters.user,
        group_code: groupCode,
      });
      commit('isNewUser', false);
      return res;
    },
    updateUser({ getters, dispatch }, groupCode) {
      return UserService.updateUser({
        ...getters.user,
        group_code: groupCode,
      })
        .then((res) => dispatch('getUser', res.user_id)
          .then(() => res));
    },
    deleteUser({ getters }) {
      return UserService.deleteUser(getters.user)
        .then((res) => {
          if (res.hasOwnProperty('user_id')) {
            User.delete(res.user_id);
          }
          return res;
        });
    },
    clearCurrentUser({ state, dispatch }) {
      if (state.isNewUser === true) {
        dispatch('deleteCurrentUser');
      }
    },
    deleteCurrentUser({ state }) {
      User.delete(state.userId);
    },
  },
  getters: {
    users() {
      return User.query()
        .withAllRecursive()
        .all();
    },
    user(state) {
      if (!state.userId) {
        return null;
      }
      return User.query()
        .withAllRecursive()
        .find(state.userId);
    },
    usersGroups() {
      return UserGroup.all();
    },
  },
};
